import {VGNav} from "vgnav";
import {VGLawCookie} from "vglawcookie";
import {VGFormSender} from "vgformsender";
import {VGSelect} from "vgselect";
import {VGSidebar} from 'vgnav/src/VGSidebar';
import slideNav from "./modules/slidenav";
import {VGMap} from "../../../../modules/index.esm";

const VGListener = {
	onReady: () => {
		VG.defaults();
		VG.plugins.init();
		VG.Scroll.ToTop.init($(window));
		VG.Scroll.LoadMap.yaMap('#yaMap');
		VG.Scroll.Header.init($(window));

		// [vegas]
		VG.log();
	},

	onLoad: () => {

	},

	onScroll: ($self) => {
		VG.Scroll.ToTop.init($self);
		VG.Scroll.LoadMap.yaMap('#yaMap');
		VG.Scroll.Header.init($self);
	},

	onResize: ($self) => {
		VG.plugins.enableSlideNav();
	},
}

const VG = {
	log: function (errors = []) {
		if (!errors.length) {
			console.log("%cVG app was initialization", "color: green;");
		} else {
			errors.forEach(function (item) {
				console.error(item);
			});
		}
	},

	defaults: () => {
		// Манипуляции с контентом по умолчанию
		$('.vg-page-default, .page-default').each(function () {
			let $self = $(this);

			// Table
			let $table = $self.find('table');
			$table.addClass('table table-hover table-bordered');
			$table.wrap('<div class="table-responsive"></div>');

			// image
			$self.find('img').addClass('img-fluid');

			$self.find('a[href=""][data-fancybox] img').each(function () {
				$(this).closest('a').attr('href', $(this).attr('src'));
			});

			// AOS
			if (enables.scrollAnimation) {
				if (typeof $self.attr('data-aos-start') !== typeof undefined && $self.attr('data-aos-start') !== false) {
					let $tags = ['p', 'li', 'h2', 'h3'],
						start = parseInt($self.data('aos-start')),
						step = 100;

					for (let i = 1; i <= $tags.length; i++) {
						let tag = $tags[i - 1],
							$tag = $self.find(tag);

						if ($tag.length) {
							$.each($tag, function () {
								start = start + step;
								$(this).attr('data-aos', 'fade-up');
								$(this).attr('data-aos-delay', start);
							});
						}
					}

					AOS.init();
				}
			}
		});
	},

	plugins: {
		init: () => {
			VG.plugins.enableAOS();
			VG.plugins.enableVGSelect();
			VG.plugins.enableVGNav();
			VG.plugins.enableLawCookie();
			VG.plugins.enableFormSender();
			VG.plugins.enableFormSendLoadings();
			VG.plugins.enableSlideNav();
			VG.plugins.enableLoadMore();
		},

		enableVGNav: function () {
			new VGNav({
				expand: 'lg',
				toggle: false
			}, {
				afterClick: function () {
					let $sidebar = new VGSidebar('#vg-nav-sidebar');
					$sidebar.close({}, true);
				}
			});
		},

		enableAOS: function () {
			if (enables.scrollAnimation) {
				AOS.init({once: true});
			}
		},

		enableVGSelect: function () {
			let elements = document.querySelectorAll('.vg-select');
			for (const element of elements) {
				new VGSelect(element, {})
			}
		},

		enableLawCookie: function () {
			new VGLawCookie();
		},

		enableFormSender: function () {
			const $forms = document.querySelectorAll('[data-vgformsender]');
			if ($forms.length) {
				$forms.forEach(function (form) {
					new VGFormSender(form).submit();
				});
			}
		},

		enableFormSendLoadings: function () {
			$('form').submit(function () {
				let $btn = $(this).find('button[type=submit]');
				let textLoading = $btn.data('loading-text');
				if (textLoading) {
					$btn.text(textLoading).attr('disabled', 'disabled');
				}
			});
		},

		enableSlideNav: function () {
			slideNav($('.products-tabs'));
			slideNav($('.services-tabs'));
		},

		enableLoadMore: function () {
			let $btn = $('.btn-load-more-photogallery');
			$btn.vegasLoadMore({
				limit: 6,
				offset: 6,
				onLoad: function ($self, data) {
					let target = $self.attr('data-target'),
						obj = data;

					if (obj.view.length) {
						$(target).append(obj.view);
					} else {
						$self.fadeOut();
					}

					if (data.cnt != 6) {
						$self.fadeOut();
					}
				},
				onClick: function ($self) {
					$self.text('Загружаю...')
				}
			});
		},
	},

	Scroll: {
		Header: {
			lastScrollTop: 0,
			body: $('body'),

			init: function ($window) {
				let $sticky = $('.header-wrapper'),
					scroll = $window.scrollTop();

				if (scroll > 0) {
					this.body.addClass('header--is-scroll');
					$sticky.addClass('scroll');

					if (scroll > this.lastScrollTop) {
						$sticky.removeClass('fixed');
						this.body.removeClass('header--is-fixed');
					} else {
						$sticky.addClass('fixed');
						this.body.addClass('header--is-fixed');
					}

					this.lastScrollTop = scroll;
				} else if (scroll === 0) {
					$sticky.removeClass('scroll').removeClass('fixed');
					this.body.removeClass('header--is-scroll header--is-fixed');
				}
			},
		},

		ToTop: {
			posActive: 400,
			btn: 'btn-scroll-to-top',

			init: function ($window) {
				let $layoutScrollToTop = $('#' + this.btn);

				if (!$layoutScrollToTop.length) {
					$('body').append('<div class="to-top" id="' + this.btn + '"><span><i class="fal fa-chevron-up"></i></span></div>')

					this.setPosition($window);
				}

				let $btnScrollToTop = $('#' + this.btn + ' span');
				$btnScrollToTop.click(function () {
					window.scrollTo(0, 0);

					return false;
				});
			},

			setPosition: function ($window) {
				let $sticky = $('#' + this.btn),
					scroll = $window.scrollTop();

				if (scroll >= this.posActive) {
					$sticky.addClass('is-active');
				} else {
					$sticky.removeClass('is-active');
				}
			}
		},

		LoadMap: {
			isInit: false,
			yaMap: function (map) {
				let $map = document.querySelector(map);

				if ($map) {
					let offsetTop = $map.getBoundingClientRect().top,
						windowHeight = window.innerHeight,
						offset = offsetTop - windowHeight;

					if (offset < 100 && !this.isInit) {
						VGMap.init($map);
						this.isInit = true;
					}
				}
			}
		}
	},
}


export default VGListener;
